import translateFileUrl from './translateFileUrl';
import { staticCache, staticFiles, privacyPolicy } from '../../config';

async function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(staticCache, 1);
    request.onerror = (event) => reject(event.target.errorCode);
    request.onsuccess = (event) => resolve(event.target.result);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      db.createObjectStore(staticCache);
    };
  });
}

async function saveData(key, value) {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([staticCache], 'readwrite');
    const store = transaction.objectStore(staticCache);
    const request = store.put(value, key);
    request.onerror = (event) => reject(event.target.errorCode);
    request.onsuccess = () => resolve();
  });
}

async function checkCasheSupported() {
  try {
    if ('caches' in window) {
      await caches.open(staticCache);
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}
export default async function cacheStaticContent(language) {
  const check = await checkCasheSupported();
  let cache;
  if (!check) {
    await openDatabase();
  } else {
    cache = await caches.open(staticCache);
  }

  const promises = Object.values(staticFiles).map((file) => {
    try {
      const _file = translateFileUrl(language, file);
      return !check ? saveData(_file, _file) : cache?.add(_file);
    } catch (e) {
      return null;
    }
  });

  const promise2 = new Promise((resolve) => {
    try {
      const _file2 = translateFileUrl(language, privacyPolicy[language.toUpperCase()]);
      resolve(!check ? saveData(_file2, _file2) : cache?.add(_file2));
    } catch (e) {
      resolve(null);
    }
  });

  await Promise.all([promises, promise2]);
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: 'carcheck.staticContent',
    }),
  );
}
